import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import ArticlesGrid from '../components/ArticlesGrid';
import Pagination from '../components/Pagination';
import { useSiteData } from '../data/SiteDataContext';
import { VIDEOS_PATH } from '../../utils/video';
import { POSTS_PER_PAGE } from './HomePage';

function ArticlesCallout() {
    return (
        <Link className="kind-switch-link kind-switch-link--articles" to="/">
            <span className="kind-switch-link__arrow" aria-hidden="true">←</span>
            <span className="kind-switch-link__text">Back to the Articles</span>
        </Link>
    );
}

// Condoned Media: every video post (another creator's video paired with our
// commentary), laid out like a category archive.
function VideosPage() {
    const { pageNum } = useParams();
    const { status, mediaPosts } = useSiteData();

    const totalPages = Math.max(1, Math.ceil(mediaPosts.length / POSTS_PER_PAGE));
    const requestedPage = pageNum ? parseInt(pageNum, 10) : 1;
    const currentPage = Number.isFinite(requestedPage) ? requestedPage : 1;

    if (pageNum && (!Number.isFinite(requestedPage) || requestedPage < 2)) {
        return <Navigate to={VIDEOS_PATH} replace />;
    }

    if (status === 'ready' && currentPage > totalPages) {
        return <Navigate to={VIDEOS_PATH} replace />;
    }

    const start = (currentPage - 1) * POSTS_PER_PAGE;
    const pagePosts = mediaPosts.slice(start, start + POSTS_PER_PAGE);

    let body;
    if (status === 'loading') {
        body = <p className="small-meta site-loading">Loading …</p>;
    } else if (status === 'error') {
        body = <p className="small-meta site-loading">Failed to load documents. Refresh to retry.</p>;
    } else if (pagePosts.length === 0) {
        body = <p className="small-meta site-loading">Nothing has been condoned yet. Check back soon.</p>;
    } else {
        body = (
            <>
                <ArticlesGrid posts={pagePosts} />
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    ariaLabel="Videos pagination"
                    getPageLink={(page) => (page <= 1 ? VIDEOS_PATH : `${VIDEOS_PATH}/page/${page}`)}
                />
            </>
        );
    }

    return (
        <>
            <ArticlesCallout />
            <header className="archive-header">
                <div className="eyebrow" style={{ marginBottom: '.4rem' }}>Watch &amp; Read</div>
                <h1>Condoned Media</h1>
                <p className="archive-intro">
                    Videos by other creators that we vouch for, each paired with our own
                    commentary. The video plays here, with our write-up beneath it — follow
                    the links to the original channels to support the people who made them.
                </p>
            </header>
            {body}
        </>
    );
}

export default VideosPage;
